import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { detectBrowserLocale, getLocaleFromCurrentUser } from '../../util/genericHelpers';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

export const loadData = (params, search) => (dispatch,getState) => {
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  const { currentUser } = getState().user;
     const savedLocale = currentUser && currentUser?.id && getLocaleFromCurrentUser(currentUser);
    const detectedLocale = detectBrowserLocale();
    const locale = savedLocale || detectedLocale || 'en';
    console.log('locale', locale)
  return dispatch(fetchPageAssets(pageAsset, true));
};
